import 'babel-polyfill'
import Vue from 'vue';
import Vuex from 'vuex';
import Tab from './modules/token.js';
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const store = new Vuex.Store({
  ...Tab,
  plugins:[createPersistedState({
    localStorage:{
      getItem:key=>localStorage.getItem(key),
      setItem:(key,value)=>localStorage.setItem(key,value)
    }
  })]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js